import DebugState from '../storage/DebugState';

class LogController {
  static log(...msg: any[]) {
    if (DebugState.isDebugJavaScript) {
      console.log(...msg);
    }
  }

  static error(...msg: any[]) {
    console.error(...msg);
  }
}

export const log = LogController.log;
export const error = LogController.error;

export default LogController;
